import { render, staticRenderFns } from "./MainLedgerList.vue?vue&type=template&id=97896394&scoped=true"
import script from "./MainLedgerList.vue?vue&type=script&lang=js"
export * from "./MainLedgerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97896394",
  null
  
)

export default component.exports